'use strict';

/**
 * @description Help Component
 * @returns {Object} Devuelve la instancia del componente
 */

import i18n from 'i18next';
import { store } from '../../app.init.js';
import { servicesAyuda } from './ayuda.services.js';
import { templateAyuda } from './ayuda.template.js';

let componentAyuda = (function () {
  let context = {};
  let handlers = {};
  let renderSuccess = false;

  let preRenderComponent = () => {
    // Asi accedemos a la propiedad del store
    const state = store.getState();
    document.title = `${i18n.t('help')} | ${i18n.t('page_subtitle')}`;
    context.name = state.exampleReducer.name;
  };

  let renderComponent = async () => {
    const state = store.getState();
    try {
      // Render the template to the document
      let contactData = await servicesAyuda.init(
        state.exampleReducer.currentLang
      );
      templateAyuda(context, handlers, contactData);

      renderSuccess = true;
    } catch (error) {
      renderSuccess = false;
    }
    document.querySelector('.esios-footer').classList.add('esios-footer--help');
  };

  let postRenderComponent = () => {
    const state = store.getState();
    context.name = state.exampleReducer.name;
  };

  let init = () => {
    //Call pre render component
    preRenderComponent();

    // Call render component
    renderComponent();
    // Call post render component if it has been rendered
    renderSuccess ? postRenderComponent() : '';
  };

  return {
    render: init,
  };
})();

export { componentAyuda };
